import { Link } from "react-router-dom";

// Internal paths and hash links go through the router; everything else is a plain anchor.
export const SmartLink = ({ href = "#", children, ...rest }) => {
  const external = /^(https?:|mailto:|tel:)/.test(href) || href === "#";
  if (external) {
    return (
      <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel={href.startsWith("http") ? "noopener noreferrer" : undefined} {...rest}>
        {children}
      </a>
    );
  }
  const to = href.startsWith("#") ? `/${href}` : href;
  return (
    <Link to={to} {...rest}>
      {children}
    </Link>
  );
};
